import type {CallLine, PhoneCallLeg} from '../model/types';

export const phoneTitleOf = (leg: PhoneCallLeg): string => leg.identity.name ?? leg.identity.number ?? leg.dialNumber ?? '';

export const lineTextOf = (line: CallLine): string => (line.label ? `${line.label} · ${line.number}` : line.number);
